import { useTranslation } from "react-i18next";
import { isString } from "lodash";
import { EN_NAME_OPTIONS } from "~/constans/commom";

export const useSetSelectFilterOption = () => {
  const { t } = useTranslation();
  return (opt, type = null) => {
    const option = EN_NAME_OPTIONS.includes(opt) ? opt.slice(0, -2) : opt;
    const isOptionDefault = option === "ui.filter_by";
    return {
      label: type
        ? isOptionDefault
          ? t(`${option}`)
          : t(`${type}.${option}`)
        : option,
      value: isOptionDefault ? "" : option,
    };
  };
};

export const useSetSelectOption = () => {
  const { t } = useTranslation();
  return (option, type = null) => {
    const isOptionDefault = [
      "place.region",
      "place.federalArea",
      "common.not_selected",
      "sections_only",
    ].includes(option?.label || option);

    if (typeof option === "object" && option !== null) {
      return {
        label: option.label,
        value: option.value,
      };
    }

    return option
      ? {
          label:
            type && !isOptionDefault && isString(option)
              ? t(`${type}.${option}`)
              : isOptionDefault
              ? t(`${option}`)
              : option,
          value: isOptionDefault ? null : option,
        }
      : null;
  };
};
